<div
  [ngClass]="{ 'application-content': stepper.selected?.label === ApplicationStepperLabels.SUMMARY}"
>
  <div class="application-title-container" *ngIf="showTitle">
    <h1
      class="applicationTitle applicationTitle-navigation"
      appConfigSettingsTitle
      appConfigSettingsBackground
    >
      <span>
        {{ "ApplicationPage.Title" | translate }}
      </span>
    </h1>
  </div>
  <div
    *ngIf="stepper.selected?.label !== ApplicationStepperLabels.FINAL"
    class="application-navigation"
  >
    <app-navigation-component
      (navigationStepsReady)="setActiveStep()"
      [productType]="productType"
    ></app-navigation-component>
  </div>
  <div class="application-stepper">
    <mat-horizontal-stepper
      (selectionChange)="stepperChangeHandler($event)"
      [linear]="isLinear"
      #stepper
    >
      <mat-step
        [label]="ApplicationStepperLabels.FIRST_INSURED"
        [stepControl]="applicationFormGroup.get('insured')"
      >
        <ng-template matStepLabel>
          <div appConfigSettingsParagraph>{{'ApplicationPage.Insured' | translate}}</div>
        </ng-template>
        <div class="secondTitle">
          <h2 appConfigSettingsSecondTitle>
            {{'ApplicationPage.Insured' | translate}}
            <span>{{ insuredBirthDate ? '(' + insuredBirthDate + ')' : '' }}</span>
          </h2>
        </div>
        <app-application-insured
          [insuredFormGroup]="applicationFormGroup.get('insured')"
        ></app-application-insured>
        <div class="buttons-wrapper">
          <app-back-button
            [stepper]="stepper"
          ></app-back-button>
          <button
            appConfigSettingsPrimaryButton
            class="buttonRight primary"
            (click)="nextFromFirstInsured()"
          >
            {{'ApplicationPage.Next' | translate}}
          </button>
        </div>
      </mat-step>
      <mat-step
        [label]="ApplicationStepperLabels.SECOND_INSURED"
        [stepControl]="applicationFormGroup.get('insured2')"
        appConfigSettingsParagraph
        *ngIf="isSecondInsured"
      >
        <ng-template class="templateList" matStepLabel>
          <div appConfigSettingsParagraph>{{'ApplicationPage.Insured2' | translate}}</div>
        </ng-template>

        <div class="secondTitle">
          <h2 appConfigSettingsSecondTitle>
            {{'ApplicationPage.Insured2' | translate}}
            <span>{{ insured2BirthDate ? '(' + insured2BirthDate + ')' : '' }}</span>
          </h2>
        </div>
        <app-application-second-insured
          [insuredFormGroup]="applicationFormGroup.get('insured2')"
        ></app-application-second-insured>
        <div class="buttons-wrapper">
          <app-back-button
            [stepper]="stepper"
          ></app-back-button>
          <button
            appConfigSettingsPrimaryButton
            class="buttonRight primary"
            (click)="nextFromSecondInsured()"
          >
            {{'ApplicationPage.Next' | translate}}
          </button>
        </div>
      </mat-step>
      <mat-step
        [label]="ApplicationStepperLabels.SECOND_POLICY_HOLDER"
        [stepControl]="applicationFormGroup.get('policyHolder2')"
        *ngIf="isSecondInsured && applicationFormGroup.get('policyHolder').value.policyHolderType != CustomerTypeEnum.ORGANISATION"
        [optional]="true"
      >
        <ng-template matStepLabel>
          <div appConfigSettingsParagraph>{{'ApplicationPage.PolicyHolder' | translate}}</div>
        </ng-template>
        <div class="secondTitle">
          <h2 appConfigSettingsSecondTitle>{{'ApplicationPage.PolicyHolder' | translate}}</h2>
        </div>
        <app-application-policy-holder-two
          [policyHolderFormGroup]="applicationFormGroup.get('policyHolder2')"
        ></app-application-policy-holder-two>
        <div class="buttons-wrapper">
          <app-back-button
            [stepper]="stepper"
          ></app-back-button>
          <button
            matStepperNext
            appConfigSettingsPrimaryButton
            class="buttonRight primary"
          >
            {{'ApplicationPage.Next' | translate}}
          </button>
        </div>
      </mat-step>
      <mat-step
        [label]="ApplicationStepperLabels.BENEFICIARIES"
        [stepControl]="applicationFormGroup.get('beneficiaries')"
      >
        <ng-template matStepLabel>
          <div appConfigSettingsParagraph>{{'ApplicationPage.Beneficiaries' | translate}}</div>
        </ng-template>
        <div class="secondTitle">
          <h2 appConfigSettingsSecondTitle>{{'ApplicationPage.Beneficiaries' | translate}}</h2>
        </div>
        <app-application-beneficiaries
          [beneficiariesFormGroup]="applicationFormGroup.get('beneficiaries')"
        ></app-application-beneficiaries>
        <div class="beneficiary-next-button-container buttons-wrapper">
          <app-back-button
            [stepper]="stepper"
          ></app-back-button>
          <button
            appConfigSettingsPrimaryButton
            class="buttonRight primary"
            (click)="nextFromBeneficiary()"
          >
            {{'ApplicationPage.Next' | translate}}
          </button>
        </div>
      </mat-step>
      <mat-step
        [label]="ApplicationStepperLabels.INSURANCE"
        [stepControl]="applicationFormGroup.get('purposeOfTheInsurance')"
      >
        <app-application-insurance
          [applicationFormGroup]="applicationFormGroup"
          [isSecondInsured]="isSecondInsured"
        ></app-application-insurance>
        <div class="insurance-next-button-container buttons-wrapper">
          <app-back-button
            [stepper]="stepper"
          ></app-back-button>
          <button
            appConfigSettingsPrimaryButton
            class="buttonRight primary"
            (click)="nextFromOtherInsurances()"
          >
            {{'ApplicationPage.Next' | translate}}
          </button>
        </div>
      </mat-step>
      <mat-step
        [label]="ApplicationStepperLabels.SUMMARY"
      >
        <ng-template matStepLabel>
          <div appConfigSettingsParagraph>{{'ApplicationPage.ClosingStatement' | translate}}</div>
        </ng-template>
        <app-application-summary
          (submitClicked)="goToStartIdentificationPage()"
          [stepper]="stepper"
        ></app-application-summary>
      </mat-step>
      <mat-step
        [label]="ApplicationStepperLabels.FINAL"
      >
<!--        <ng-template matStepLabel>-->
<!--          <div appConfigSettingsParagraph>-->
<!--            {{'IdentificationPage.Title' | translate}}-->
<!--          </div>-->
<!--        </ng-template>-->
<!--        <app-application-start-identification-->
<!--          *ngIf="showStartIdentificationPage"-->
<!--          (idinIssuerSelectionChanged)="onSelectedIdinIssuer($event)"-->
<!--        ></app-application-start-identification>-->

<!--        <app-idin-verification-failed-page-->
<!--          (resetApplication)="this.resetApplication()"-->
<!--          *ngIf="showIdinVerificationFailedPage"-->
<!--        ></app-idin-verification-failed-page>-->

<!--        <app-idin-verification-error-page-->
<!--          (resetApplication)="this.resetApplication()"-->
<!--          *ngIf="showIdinVerificationErrorPage"-->
<!--        ></app-idin-verification-error-page>-->

<!--        <app-idin-verification-cancelled-page-->
<!--          *ngIf="showIdinVerificationCancelledPage"-->
<!--        ></app-idin-verification-cancelled-page>-->

<!--        <app-idin-verification-success-page-->
<!--          *ngIf="showIdentityVerifiedPage"-->
<!--        >-->
<!--        </app-idin-verification-success-page>-->

        <app-application-thank-you
          firstParagraph="ThankYouPage.Insured1FirstParagraph"
          subTitle="ThankYouPage.Insured1BoldTitle"
          secondParagraph="ThankYouPage.Insured1SecondParagraph"
          thirdParagraph="ThankYouPage.Insured1ThirdParagraph"
          fourthParagraph="ThankYouPage.Insured1FourthParagraph"
          downloadPdf="ThankYouPage.DownloadPDF.0"
          *ngIf="showIdentityVerifiedThankYouPage == true"
          (resetApplication)="this.resetApplication()"
        ></app-application-thank-you>

<!--        <div class="full-width buttonCenteredContainer">-->
<!--          <button-->
<!--            *ngIf="showStartIdentificationPage"-->
<!--            class="primary"-->
<!--            mat-button-->
<!--            appConfigSettingsButton-->
<!--            (click)="goBack()"-->
<!--          >-->
<!--            {{'IdentificationPage.BackButton' | translate}}-->
<!--          </button>-->

<!--          <button-->
<!--            *ngIf="showStartIdentificationPage"-->
<!--            class="primary"-->
<!--            mat-button-->
<!--            appConfigSettingsButton-->
<!--            (click)="sendAuthenticationRequest()"-->
<!--          >-->
<!--            {{'IdentificationPage.NextStepButton' | translate}}-->
<!--          </button>-->

<!--          <button-->
<!--            *ngIf="showIdinVerificationFailedPage"-->
<!--            class="primary"-->
<!--            mat-button-->
<!--            appConfigSettingsButton-->
<!--            (click)="redirectToCalculationPage()"-->
<!--          >-->
<!--            {{'IdinVerificationFailedPage.AnotherCalculation' | translate}}-->
<!--          </button>-->
<!--        </div>-->
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
